import { Directive, inject } from "@angular/core";

import { LoggerService } from "@mp/core/services/logger.service";

@Directive()
export abstract class Base {
    protected readonly log: {
        debug: (msg: string, ...others: any) => void;
        warn: (msg: string, ...others: any) => void;
        err: (msg: string, ...others: any) => void;
        info: (msg: string, ...others: any) => void;
    };

    protected constructor() {
        const logger = inject(LoggerService);

        this.log = {
            debug: (msg: string, ...others: any): void => {
                logger.debug(this.composeMessage(msg), ...others);
            },
            warn: (msg: string, ...others: any): void => {
                logger.warn(this.composeMessage(msg), ...others);
            },
            err: (msg: string, ...others: any): void => {
                logger.err(this.composeMessage(msg), ...others);
            },
            info: (msg: string, ...others: any): void => {
                logger.info(this.composeMessage(msg), ...others);
            }
        };
    }

    private composeMessage(msg: string): string {
        return "[" + this.constructor.name + "] " + msg;
    }
}
